import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, doc, docData, getDoc, query, setDoc, updateDoc, where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SharedService } from '../../../../shared/shared.service';
import { getDownloadURL, getStorage, ref } from '@angular/fire/storage';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
	constructor(
		private firestore: Firestore,
		private sharedService: SharedService,
		private httpClient:  HttpClient
	) { }

	getCategories() {
		const categoriesRef = collection(this.firestore, 'categories');
		const q = query(categoriesRef, where('visible', '==', true))
		return collectionData(q, { idField: 'id' }) as Observable<any>;
	}

	getOrganisation(){
		const ref = collection(this.firestore, 'organisations');
		return collectionData(ref, {idField: 'id'}) as Observable<any>;
	}

	getPrograms(userId:any){
		const ref = collection(this.firestore, 'progress');
		const q = query(ref, where('userId', '==', userId))
		return collectionData(ref, {idField: 'id'}) as Observable<any>;
	}

	addEditOrganization(data: any, id:string) {
		let collectionRef = 'organisations';
		if(!id) {
		id = doc(collection(this.firestore, collectionRef)).id;
		}
		collectionRef = `organisations/${id}`;
		const ref = doc(this.firestore, collectionRef);
		return setDoc(ref, data);
	}

	async getOrgLevels(orgId: string) {
		try {
			let orgLevels: any = [];
			let docRef = doc(this.firestore, `organisations/${orgId}`);
			const orgDataObs = docData(docRef, {
				idField: "id"
			});
			const orgData: any = await this.sharedService.getObservableRes(orgDataObs);
			for (let hierarchy of orgData.hierarchies) {
				orgLevels.push(hierarchy);
			}

			return orgLevels;
		} catch (err) {
			console.log('Unable to get org levels!', err);
		}
	}

	async getOrgData(orgId: string) {
		try {
			if (orgId) {
				let docRef = doc(this.firestore, `organisations/${orgId}`);
				const orgDataObs = docData(docRef, {
					idField: "id"
				});
				return await this.sharedService.getObservableRes(orgDataObs);
			}

			return "";
		} catch (err) {
			console.log('Unable to get org levels!', err);
		}
	}

	async getAllSystemPrograms() {
		try {
			let programs: any = [];
			const programsDataObs = collectionData(collection(this.firestore, "programs"));
			const programsData: any = await this.sharedService.getObservableRes(programsDataObs);

			for (let program of programsData) {
				programs.push({
					id: program.id,
					name: program.name
				});
			}
			return programsData;
		} catch (err) {
			console.log('Unable to get all system programs!', err);
		}
	}

	async getAnalyticsData(orgId: string) {
		try {
			return new Promise(async (resolve, reject) => {
				const storage = getStorage();
				const analyticsDataRef = ref(storage, `analytics/${orgId}/data.json`);
				const url = await getDownloadURL(analyticsDataRef);

				this.httpClient.get<{analyticsData: any}>(url, {
					responseType: 'json'
				}).subscribe(data => {
					// console.log(data);
					resolve(data.analyticsData);
				});
			});
		} catch (err) {
			console.log('Unable to get analytics data!', err);
		}
	}

	getAnalyticsStatus(orgId: string) {
		return docData(doc(this.firestore, `organisations/${orgId}`));
	}

	async updateAdminAnalyticsCollection(orgId: string, data: any) {
		try {
			const docRef = doc(this.firestore, `adminAnalytics/${orgId}`);
			await setDoc(docRef, data);
		} catch (err) {
			console.log('Unable to update admin analytics', err);
		}
	}

	async getCommunityAnalytics() {
		try {
			const communityAnalytics = docData(doc(this.firestore, 'communityAnalytics/data'));
			return await this.sharedService.getObservableRes(communityAnalytics);
		} catch (err) {
			console.log(err);
		}
	}

	// async getInitialData(orgId: string) {
	// 	try {
	// 		const docRef = doc(this.firestore, `adminAnalytics/${orgId}`);
	// 		const dataObs = docData(docRef);
	// 		const adminData = await this.sharedService.getObservableRes(dataObs);
	// 		return adminData;
	// 	} catch (err) {
	// 		console.log('Unable to get admin analytics initial data', err);
	// 	}
	// }
}
